import React from 'react';
import { Box, Text } from '@mantine/core';

const PriceBreaksTab = ({ selectedLineId }) => {
  return (
    <Box p="md">
      <Text>Price Breaks tab content for Line {selectedLineId} - to be implemented</Text>
    </Box>
  );
};

export default PriceBreaksTab;